import { createAction, props } from '@ngrx/store';

import { CountryModel } from 'common/src/modules/rnpl-common/models';
import { UIStatesEnum } from 'common/src/models';
import { PartnersListState } from '../reducers';
import { PrivatePartnerModel } from '../../models/partner.model';
import { PartnersListTabsEnum } from '../../enums/partners-list-tabs.enum';
import { Validation } from 'projects/workspace/src/app/shared/models/response';
import { Title } from 'projects/workspace/src/app/administration/models/company-profile.model';

export const LoadPartnersList = createAction(
  '[Private Partner] Load Partners List',
  props<{ partnerListData: PartnersListState, status: PartnersListTabsEnum }>()
);

export const LoadPartner = createAction(
  '[Private Partner] Load Partner',
  props<{ partner: PrivatePartnerModel }>()
);

export const LoadCountries = createAction(
  '[Private Partner] Load Countries',
  props<{ countries: CountryModel[] }>()
);

export const UpdatePartnerState = createAction(
  '[Private Partner] Update Partner Current State',
  props<{ currentState: UIStatesEnum }>()
);

export const UpdatePartnerUpdatedAt = createAction(
  '[Private Partner] Update Partner updatedAt',
  props<{ updatedAt: Date }>()
);

export const UpdateShouldRefreshEntity = createAction(
  '[Private Partner] Update Partner should refresh flag',
  props<{ isShouldRefresh: boolean }>()
);

export const ClearPartnerUpdatedAt = createAction(
  '[Private Partner] Clear Partner updatedAt'
);

export const LoadTitles = createAction(
  '[Private Partner] Load Titles',
  props<{ titles: Title[] }>()
);

export const UpdateValidations = createAction(
  '[Private Partner] Update Validations',
  props<{ validations: Validation[] }>()
);

export const ResetValidations = createAction(
  '[Private Partner] Reset Validations'
);

export const IncrementLoadingRequestsCount = createAction(
  '[Private Partner] Increment Loading Requests Count'
);

export const DecrementLoadingRequestsCount = createAction(
  '[Private Partner] Decrement Loading Requests Count'
);
